import React from 'react';
import { Image } from './elements';

type TIPimg01Props = {
  readonly className?: string;
  readonly onClick: () => void;
  readonly backgroundSize: string;
  readonly height: string;
  readonly image: string;
  readonly width: string;
};

export default function TIPimg01({
  className,
  onClick,
  backgroundSize,
  height,
  image,
  width,
}: TIPimg01Props) {
  return (
    <div className={className}>
      <Image
        onClick={onClick}
        $backgroundSize={backgroundSize}
        $height={height}
        $image={image}
        $width={width}
      />
    </div>
  );
}
